export const caseClosureReasonPathName = 'case-closure-reason'; // Sager: Afslutningsårsager
export const caseContactReasonPathName = 'case-contact-reason'; // Sager: Henvendelsesårsager
export const caseGroupPathName = 'case-group'; // Sager: Sagsgrupper
export const associateUserRolePathName = 'associate-user-role'; // Sager: Supplerende sagsbehandlerroller
export const caseTypePathName = 'case-type'; // Sager: Sagstyper
export const caseRestrictionPathName = 'case-restrictions'; // Sager: Sagsafskærmning
